export const ru = {
    heading: 'Настроим вашу первую кампанию в Директе',
    subheading:
        'Если вам нужна помощь в настройке кампании, воспользуйтесь услугами специалистов',
    'title-agency': 'Выбрать сертифицированное рекламное агентство',
    'title-freelancer': 'Выбрать частного специалиста по настройке',
    'title-yandex': 'Получить настройку рекламы от специалиста Яндекса'
};
